const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.onbookmarks.com';

const headers = () => {
  const i18n = require('../utils/i18n').default;
  return {
    'Content-Type': 'application/json',
    'Accept-Language': i18n.language || 'en',
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};

export const fetchPricing = async (country) => {
  try {
    const url = country
      ? `${API_BASE_URL}/v1/subscription/pricing?country=${encodeURIComponent(country)}`
      : `${API_BASE_URL}/v1/subscription/pricing`;
    const response = await fetch(url, {
      method: 'GET',
      headers: headers(),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error('Error fetching pricing:', error);
    throw error;
  }
};

export const fetchDirectory = async (limit = 20, offset = 0) => {
  try {
    const response = await fetch(`${API_BASE_URL}/v1/collections/directory?limit=${limit}&offset=${offset}`, {
      method: 'GET',
      headers: headers(),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error('Error fetching directory:', error);
    throw error;
  }
};

export const fetchPublicCollection = async (uuid, domain) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/v1/collections/public/${uuid}/${domain}`,
      { method: 'GET', headers: headers() }
    );
    return await handleResponse(response);
  } catch (error) {
    console.error('Error fetching public collection:', error);
    throw error;
  }
};